import React, {useEffect, useState} from "react";
import {Card, Form} from "antd";
import {FormComponentProps} from "antd/lib/form";
import PageWrapper from "pages/wrapper/PageWrapper";
import ButtonCancel from "components/common/form/button/ButtonCancel";
import RadioWithLabel from "components/common/form/input-with-label/RadioWithLabel";
import InputWithLabel from "components/common/form/input-with-label/InputWithLabel";
import SelectWithLabel from "components/common/form/input-with-label/SelectWithLabel";
import _ from "lodash";
import {match} from "react-router";
import {onFailAction} from "helpers/SwalCommon";
import SelectDateWithLabel from "components/common/form/input-with-label/SelectDateWithLabel";
import moment from "moment";
import {RequestDigitalCertificatePersonalServices} from "../../services/request-digital-certificate-personal/RequestDigitalCertificatePersonalServices";
import {RequestCertificateGroupService} from "../../services/request-certificate-group/RequestCertificateGroupServices";
import {formatMoney} from "../../helpers/NewCaCrmHelper";
import {TextAreaWithLabel} from "../../components/common/form/input-with-label/TextAreaWithLabel";
const { REACT_APP_BASE_API_URL } = window['runConfig'];
interface Props extends FormComponentProps {
    match: match<{ id: string }>;
    history: any;
}

export const RequestCTSPersonalUpdate: React.FC<Props> = props => {
    const id = props.match.params.id;

    const [provideDate, setProvideDate] = useState("");
    const [represenProvideDate, setRepresenProvideDate] = useState("");
    const [status, setStatus] = useState(0);
    const [reason, setReason] = useState("");
    const [cateServicePackage, setCateServicePackage] = useState({});
    const [secretCode, setSecretCode] = useState("");
    const [password, setPassword] = useState("");
    const [cateServicePackageAmount, setCateServicePackageAmount] = useState([]);
    const [statusReqGen, setStatusReqGen] = useState(false);

    const [isFileDk03, setIsFileDk3] = useState(false);
    const [province, setProvince] = useState({});
    const [district, setDistrict] = useState({});
    const [labelCode, setLabelCode] = useState("Mã số doanh nghiệp");
    const onChange = async value => {
        const selectdCate: any = _.find(cateServicePackageAmount, { id: parseInt(value) });
        if(selectdCate){
            props.form.setFieldsValue({ package_price: selectdCate.price });
        }
    };
    const fetchRequestPersonal = async () => {
        const result = await RequestCertificateGroupService.getRequestCertificate(id);
        const province = await RequestCertificateGroupService.getProvince();
        setProvince(_.mapValues(_.keyBy(province, "newtel_code"), "fullname"));
        const district = await RequestCertificateGroupService.getDistrictByProvince(result.data.province_code);
        setDistrict(_.mapValues(_.keyBy(district, "newtel_district_code"), "fullname"));

        if(Number(result.data.status) === 5 ){
            setStatusReqGen(true);
          }
        setProvideDate(result.data.organization.provide_date);
        setRepresenProvideDate(result.data.organization.represen_passport_date);
        setReason(result.data.reason);
        setStatus(result.data.status);
        setSecretCode(result.data.secret_code);
        setPassword(result.data.password);
        props.form.setFieldsValue({
            type_legal: result.data.organization.type_legal.toString(),
            identity_type: result.data.organization.identity_type.toString(),
            code: result.data.organization.code,
            provide_organization: result.data.organization.provide_organization,
            tax_code: result.data.organization.tax_code,
            fullname: result.data.organization.fullname,
            address: result.data.organization.address,
            email: result.data.organization.email,
            phone: result.data.organization.phone,
            quantity: result.data.quantity,
            object: result.data.object.toString(),
            type_docurment: result.data.type_docurment.toString(),
            type_device: result.data.type_device.toString(),
            package_id: result.data.package_id.toString(),
            package_price:formatMoney(result.data.package_price),
            represent_fullname: result.data.organization.represent_fullname,
            represen_passport: result.data.organization.represen_passport,
            represen_passport_place: result.data.organization.represen_passport_place,
            represen_position: result.data.organization.represen_position,
            represen_email: result.data.organization.represen_email,
            represen_phone: result.data.organization.represen_phone,
            province_code: result.data.province_code.toString(),
            district_code: result.data.district_code.toString(),
            sp_fullname: result.data.requestsupport.fullname,
            sp_position: result.data.requestsupport.position,
            sp_email: result.data.requestsupport.email,
            sp_phone: result.data.requestsupport.phone,
        });
        if (Number(result.data.object) === 2){
            props.form.setFieldsValue({
                serial_cts : result.data.serial_cts,
                token_type: result.data.token_type.toString()
            })
        }

            if (Number(result.data.organization.identity_type) === 1){
                setLabelCode("Mã số thuế");
            }if (Number(result.data.organization.identity_type) === 2){
                setLabelCode("Mã ngân sách");
            }if (Number(result.data.organization.identity_type) === 3){
                setLabelCode("Số quyết định");
            }if (Number(result.data.organization.identity_type) === 4){
                setLabelCode("Mã bảo hiểm xã hội");
            }if (Number(result.data.organization.identity_type) === 5){
                setLabelCode("Giáy phép đầu tư");
            }


        let arrAll:any = [];
        result.data.list_document.forEach(function (values) {
            arrAll[values.id] = values.type;
        });
        arrAll.forEach(function(item, index, array) {
            if(Number(item) === 7){
                setStatusReqGen(true);
            }
            if(Number(item) === 14){
                setIsFileDk3(true);
            }
        });

        const type_search = 4;
        const type = props.form.getFieldValue("object");
        const object = 3;
        const type_device = props.form.getFieldValue("type_device");
        const data = await RequestDigitalCertificatePersonalServices.getListCateServicePackage(type_search, type, object, type_device);
        setCateServicePackageAmount(data.data);
        setCateServicePackage(_.mapValues(_.keyBy(data.data, "id"), "name"));
    };
    useEffect(() => {
        fetchRequestPersonal();
        // eslint-disable-next-line
    }, []);
    const STATUS_TU_CHOI = 3;
    const STATUS_DA_DUYET = 4;
    const onViewFileDoc = async type => {
        try {
            let token = localStorage.getItem("currentUser");
            if (token){
                let obj = JSON.parse(token);
                let link = `${REACT_APP_BASE_API_URL}qlbh/yeu-cau-chung-thu-so-to-chuc/getFileDoc/${password}/${type}?token=${obj.token}`;
                window.open(link)
            }
        } catch (error) {
            onFailAction("Có lỗi xảy ra khi xem trước file!");
        }
    };
    return (
        <PageWrapper title="Xem chi tiết yêu cầu chứng thư số đối với tổ chức">
            <Form>
                {status === STATUS_TU_CHOI ? (
                    <div className="input-group">
                        {" "}
                        <TextAreaWithLabel
                            label={"Lý do từ chối"}
                            name="reason-deny"
                            rows={0}
                            form={props.form}
                            defaultValue={reason}
                            wrapClass={"col-md"}
                            isDisabled={true}
                        />{" "}
                    </div>
                ) : (
                    ""
                )}
                {status === STATUS_DA_DUYET ? (
                    <div className="input-group">
                        {" "}
                        <InputWithLabel
                            label="Mã bảo mật"
                            form={props.form}
                            name="secret_code"
                            isDisabled={true}
                            wrapClass="col-md"
                            defaultValue={secretCode}
                        />{" "}
                    </div>
                ) : (
                    ""
                )}
                <Card className="m-r-15-i m-l-15-i mt-4" title={<label>Thông tin gói chứng thư số</label>} size="small">
                    {/*line 1*/}
                    <div className="input-group">
                        <SelectWithLabel
                            options={{
                                1: 'Mã số thuế',
                                2: 'Mã ngân sách',
                                3: 'Số quyết định',
                                4: 'Mã bảo hiểm xã hội',
                                5: 'Giấy phép đầu tư'
                            }}
                            name="identity_type"
                            wrappedClass="col-md-2"
                            form={props.form}
                            label={"Loại định danh"}
                            isRequired={true}
                            isDisabled={true}
                        />
                        <InputWithLabel
                            form={props.form}
                            label={labelCode}
                            name="code"
                            wrapClass="col-md-2"
                            maxLength={16}
                            isDisabled={true}
                        />
                        <RadioWithLabel
                            options={{1: "Cấp mới", 2: "Gia hạn", 3: "Chuyển đổi"}}
                            label="Đối tượng"
                            name="object"
                            wrappedClass="col-md-4 select-doi-tuong"
                            form={props.form}
                            isDisabled={true}
                        />
                        <RadioWithLabel
                            options={{1: "Token", 2: "HSM"}}
                            label="Thiết bị đầu cuối thuê bao"
                            name="type_device"
                            wrappedClass="col-md-2 select-doi-tuong"
                            form={props.form}
                            isDisabled={true}
                        />
                    </div>
                    <div className="input-group">
                        {Number(props.form.getFieldValue("object")) === 2 ? (
                            <React.Fragment>
                                <InputWithLabel
                                    form={props.form}
                                    label="Serial CTS"
                                    name="serial_cts"
                                    wrapClass="col-md-4"
                                    isRequired={true}
                                    isDisabled={true}
                                />
                                <SelectWithLabel
                                    options={{1: "Token mới", 2: "Token cũ"}}
                                    name="token_type"
                                    wrappedClass="col-md-2 "
                                    form={props.form}
                                    label={"Loại token"}
                                    isRequired={true}
                                    isDisabled={true}
                                />
                            </React.Fragment>
                        ): ('')}
                        <SelectWithLabel
                            options={cateServicePackage}
                            name="package_id"
                            wrappedClass="col-md-2"
                            form={props.form}
                            label={"Gói dịch vụ"}
                            isDisabled={true}
                            onChange={onChange}
                        />
                        <InputWithLabel
                            form={props.form}
                            label="Giá bán"
                            name="package_price"
                            wrapClass="col-md-2"
                            isDisabled={true}
                        />
                        <InputWithLabel
                            form={props.form}
                            label="Số lượng"
                            name="quantity"
                            wrapClass="col-md-2"
                            isRequired={true}
                            type={'number'}
                            isDisabled={true}
                        />
                    </div>
                </Card>
                <Card className="m-r-15-i m-l-15-i mt-4" title={<label>Thông tin doanh nghiệp</label>} size="small">
                    {/*line 1*/}
                    <div className="input-group">
                        <RadioWithLabel
                            options={{1: "Giấy ĐKKD", 2: "Giấy phép đầu tư", 3: "Quyết định thành lập"}}
                            label="Giấy tờ pháp lý"
                            name="type_legal"
                            wrappedClass="col-md-5 select-doi-tuong"
                            form={props.form}
                            isDisabled={true}
                        />
                        <div className="col-md-3">
                            <label className="hidden">12121</label>
                            <button className="btn btn-outline-primary form-control" onClick={()=>onViewFileDoc(1)}>Xem file pháp lý</button>
                        </div>
                        <SelectDateWithLabel
                            name="provide_date"
                            form={props.form}
                            wrapClass="col-md-2"
                            label="Ngày cấp"
                            defaultValue={provideDate ? moment(provideDate) : null}
                            isDisabled={true}
                        />
                        <InputWithLabel
                            form={props.form}
                            label="Nơi cấp"
                            name="provide_organization"
                            wrapClass="col-md-2"
                            maxLength={255}
                            isDisabled={true}
                        />
                    </div>
                    {/*line2*/}
                    <div className="input-group">
                        <InputWithLabel
                            form={props.form}
                            label="MST (nếu có)"
                            name="tax_code"
                            wrapClass="col-md-2"
                            maxLength={16}
                            isDisabled={true}
                        />
                        <InputWithLabel
                            form={props.form}
                            label="Tên doanh nghiệp"
                            name="fullname"
                            wrapClass="col-md-4"
                            maxLength={255}
                            isDisabled={true}
                        />
                        <InputWithLabel
                            form={props.form}
                            label="Số điện thoại"
                            name="phone"
                            wrapClass="col-md-2"
                            isDisabled={true}
                            maxLength={16}
                        />
                        <InputWithLabel
                            form={props.form}
                            label="Email"
                            name="email"
                            wrapClass="col-md-4"
                            isDisabled={true}
                            maxLength={255}
                            note={"Thông tin hiển thị trong CTS của doanh nghiệp"}
                        />
                    </div>
                    <div className="input-group">
                        <InputWithLabel
                            form={props.form}
                            label="Địa chỉ"
                            name="address"
                            wrapClass="col-md-8"
                            maxLength={255}
                            isDisabled={true}
                        />
                        <SelectWithLabel
                            options={province}
                            name="province_code"
                            wrappedClass="col-md-2"
                            form={props.form}
                            label={"Tỉnh thành"}
                            isDisabled={true}
                        />
                        <SelectWithLabel
                            options={district}
                            name="district_code"
                            wrappedClass="col-md-2"
                            form={props.form}
                            label={"Quận huyện"}
                            isDisabled={true}
                        />
                    </div>
                </Card>
                <Card className="m-r-15-i m-l-15-i mt-4" title={<label>Người đại diện </label>} size="small">
                    {/*line 1*/}
                    <div className="input-group">
                        <InputWithLabel
                            form={props.form}
                            label="Họ và tên"
                            name="represent_fullname"
                            wrapClass="col-md-4"
                            isDisabled={true}
                            maxLength={255}
                        />
                        <InputWithLabel
                            form={props.form}
                            label="Số CMND"
                            name="represen_passport"
                            wrapClass="col-md-3"
                            isDisabled={true}
                            maxLength={16}
                        />
                        <div className="col-md-3">
                            <label className="hidden">12121</label>
                            <button className="btn btn-outline-warning form-control" onClick={()=>onViewFileDoc(2)}>Xem file CMND/Hộ chiếu</button>
                        </div>
                        <SelectDateWithLabel
                            name="represen_passport_date"
                            form={props.form}
                            isDisabled={true}
                            wrapClass="col-md-2"
                            label="Ngày cấp"
                            defaultValue={represenProvideDate ? moment(represenProvideDate) : null}
                        />
                    </div>
                    <div className="input-group">
                        <InputWithLabel
                            form={props.form}
                            label="Nơi cấp"
                            name="represen_passport_place"
                            wrapClass="col-md-3"
                            isDisabled={true}
                            maxLength={255}
                        />
                        <InputWithLabel
                            form={props.form}
                            label="Chức vụ"
                            name="represen_position"
                            wrapClass="col-md-3"
                            isDisabled={true}
                            maxLength={255}
                        />
                        <InputWithLabel
                            form={props.form}
                            label="Email"
                            name="represen_email"
                            wrapClass="col-md-3"
                            isDisabled={true}
                            maxLength={255}
                        />
                        <InputWithLabel
                            form={props.form}
                            label="Số điện thoại"
                            name="represen_phone"
                            wrapClass="col-md-3"
                            isDisabled={true}
                            maxLength={16}
                        />
                    </div>
                </Card>
                <Card className="m-r-15-i m-l-15-i mt-4" title={<label>Thông tin đầu mối quản lý sử dụng</label>} size="small">
                        <React.Fragment>
                            <div className="input-group">
                                <div className="input-group">
                                    <InputWithLabel
                                        form={props.form}
                                        label="Họ tên đầu mối"
                                        name="sp_fullname"
                                        wrapClass="col-md-3"
                                        isDisabled={true}
                                        maxLength={255}
                                    />
                                    <InputWithLabel
                                        form={props.form}
                                        label="Chức vụ"
                                        name="sp_position"
                                        wrapClass="col-md-3"
                                        isDisabled={true}
                                        maxLength={255}
                                    />
                                    <InputWithLabel
                                        form={props.form}
                                        label="Email"
                                        name="sp_email"
                                        wrapClass="col-md-3"
                                        isDisabled={true}
                                        maxLength={255}
                                    />
                                    <InputWithLabel
                                        form={props.form}
                                        label="Số điện thoại"
                                        name="sp_phone"
                                        wrapClass="col-md-3"
                                        isDisabled={true}
                                        maxLength={16}
                                    />
                                </div>
                            </div>
                        </React.Fragment>

                </Card>
                <Card className="m-r-15-i m-l-15-i mt-4" title={<label>Mẫu đăng ký</label>} size="small">
                    <div className="input-group">
                        <RadioWithLabel
                            options={{1: "Điện tử", 2: "Giấy", 3: "Scan"}}
                            label="Loại hồ sơ"
                            name="type_docurment"
                            wrappedClass="col-md-3 select-doi-tuong"
                            form={props.form}
                            isRequired={true}
                            isDisabled={true}
                        />
                        {status === STATUS_TU_CHOI ?
                            ("") : (
                                <React.Fragment>
                                    <div className="col-md-2">
                                        <label className="invisible">11111998</label>
                                        <button onClick={() => onViewFileDoc(3)} className="btn btn-outline-success form-control">
                                            Tải xuống DK-01
                                        </button>
                                    </div>
                                </React.Fragment>
                            )
                        }
                        {statusReqGen ? (
                            <div className="col-md-2">
                            <label className="invisible">11111998</label>
                            <button className="btn btn-outline-primary form-control" onClick={()=>onViewFileDoc(4)}>Tải xuống mẫu xác nhận thông tin khách hàng</button>
                        </div>
                    
                        ) : ("")
                        }
                        {isFileDk03 ? (
                            <div className="col-md-2">
                                <label className="invisible">11111998</label>
                                <button onClick={() => onViewFileDoc(5)} className="btn btn-outline-success form-control">
                                    Tải xuống DK-03
                                </button>
                            </div>
                        ) : ("")}
                    </div>

                </Card>
            </Form>
            <div className="input-group d-flex justify-content-center p-5 mt-4">
                <div className="">
                    <ButtonCancel
                        // onClick={() => {
                        //     props.history.push("/yeu-cau-cts-to-chuc");
                        // }}
                        onClick={() => {
                            props.history.goBack();
                        }}
                        className={"btn btn-default btn-sm"}
                    />
                </div>
            </div>
        </PageWrapper>
    );
};

const WrappedRequestCTSPersonalUpdate = Form.create<Props>({
    name: "RequestCTSPersonalUpdate"
})(RequestCTSPersonalUpdate);

export default WrappedRequestCTSPersonalUpdate;
